import { request, AUTH_HEADER } from '../utils/Api';

export function play(url) {
  return dispatch => {
    dispatch({
      type: "PLAY",
      payload: url
    });
  }
}

export function pause(url) {
  return dispatch => {
    dispatch({
      type: "PAUSE",
    });
  }
}

export function addSongTopQueue(url) {
  return dispatch => {
    dispatch({
      type: "ADD_TOP_QUEUE",
      payload: url
    });
  }
}

export function addSongTopQueueDontPlay(url) {
  return dispatch => {
    dispatch({
      type: "ADD_TOP_QUEUE_NO_AUTOPLAY",
      payload: url
    });
  }
}

export function addSongToQueue(url) {
  return dispatch => {
    dispatch({
      type: "ADD_TO_QUEUE",
      payload: url
    });
  }
}

export function nextSong() {
  return dispatch => {
    dispatch({
      type: "NEXT_SONG"
    });
  }
}

export function previousSong() {
  return dispatch => {
    dispatch({
      type: "PREVIOUS_SONG"
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/player.js